<div class="od-root" [class.dark]="isDark()">

  <!-- ═══ TOP NAV BAR ════════════════════════════════════════════════ -->
  <header class="od-topbar">

    <div class="od-topbar-left">
      <!-- Back to Dashboard -->
      <button class="od-back-btn" (click)="goBack()" title="Back to Dashboard">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round">
          <line x1="19" y1="12" x2="5" y2="12"></line>
          <polyline points="12 19 5 12 12 5"></polyline>
        </svg>
      </button>

      <!-- Machine-type tabs -->
      <nav class="od-tabs">
        @for (tab of filteredMachineTypes(); track tab.id) {
        <button class="od-tab" [class.active]="activeTab()?.id === tab.id" (click)="selectTab(tab)">
          {{ tab.machineTypeName }}
        </button>
        }
      </nav>
    </div>

    <!-- Right controls -->
    <div class="od-topbar-right">

      
      <!-- @if (lastUpdatedTime()) {
      <span class="ws-time">Updated: {{ lastUpdatedTime() | date:'hh:mm:ss a' }}</span>
      }
      <span class="ws-indicator" [class.ws-live]="wsConnected() && !liveUpdateFlash()"
        [class.ws-offline]="!wsConnected()" [class.ws-updated]="liveUpdateFlash()"
        [title]="liveUpdateFlash() ? 'Data updated' : (wsConnected() ? 'Live' : 'Reconnecting…')">
        <span class="ws-dot"></span>
        {{ liveUpdateFlash() ? 'Updated' : (wsConnected() ? 'Live' : 'Offline') }}
      </span> -->

      <div class="od-dept-group">
        <span class="od-label">DEPARTMENT:</span>
        <select [ngModel]="departmentId()" (ngModelChange)="onDepartmentChange(+$event)"
          [disabled]="allowedContext() !== null" class="od-select">
          @for (dept of visibleDepartments(); track dept.departmentId) {
          <option [ngValue]="dept.departmentId">{{ dept.departmentName | titlecase }}</option>
          }
        </select>
      </div>
    </div>
  </header>

  <!-- ═══ PAGE HEADER ════════════════════════════════════════════════ -->
  <div class="od-page-header">
    <div>
      <h1 class="od-page-title">{{ activeTab()?.machineTypeName || 'Operations' }}</h1>
      <div class="flex gap-4">
        <p class="od-page-sub">Real-time status and throughput monitoring.</p>

        <div style="display: flex; gap: 16px; font-size: 13px; color: var(--text-muted, #888);">
          <span style="display: flex; align-items: center; gap: 4px;">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
              <line x1="16" y1="2" x2="16" y2="6"></line>
              <line x1="8" y1="2" x2="8" y2="6"></line>
              <line x1="3" y1="10" x2="21" y2="10"></line>
            </svg>
            {{ today }}
          </span>
          <span style="display: flex; align-items: center; gap: 4px;">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="10"></circle>
              <polyline points="12 6 12 12 16 14"></polyline>
            </svg>
            {{ currentTime }}
          </span>
        </div>
      </div>

    </div>

    <div class="od-date-controls">
      <div class="od-date-group">
        <span class="od-label">YEAR</span>
        <select [ngModel]="selectedYear()" (ngModelChange)="selectedYear.set(+$event)" class="od-select od-select-sm">
          <option *ngFor="let y of years" [ngValue]="y">{{ y }}</option>
        </select>
      </div>
      <div class="od-date-group">
        <span class="od-label">MONTH</span>
        <select [ngModel]="selectedMonth()" (ngModelChange)="selectedMonth.set(+$event)" class="od-select od-select-sm">
          <option *ngFor="let m of months" [ngValue]="m.value">{{ m.label }}</option>
        </select>
      </div>
    </div>
  </div>

  <!-- ═══ MACHINE CARDS (dynamic from API) ══════════════════════════ -->
  <div class="od-carousel-container">
    @if (machineCards().length > 3) {
    <button class="od-scroll-btn left" (click)="prevCardPage()" title="Previous Cards">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <polyline points="15 18 9 12 15 6"></polyline>
      </svg>
    </button>
    }

    <div class="od-cards-grid" [style.--col-count]="getGridColCount()">

      <!-- Loading skeleton -->
      @if (cardsLoading()) {
      @for (_ of [1,2,3]; track $index) {
      <div class="mc-card-wrapper mc-skeleton-wrapper">
        <div style="display: flex; gap: 16px; margin-bottom: 8px;">
          <div class="mc-skel" style="height: 32px; width: 120px; border-radius: 4px;"></div>
          <div class="mc-skel" style="height: 24px; width: 80px; border-radius: 12px;"></div>
        </div>
        <div class="mc-skel" style="height: 24px; width: 100%; border-radius: 4px; margin-bottom: 16px;"></div>
        <div class="mc-row-2">
          <div class="mc-subcard mc-skel" style="height: 100px;"></div>
          <div class="mc-subcard mc-skel" style="height: 100px;"></div>
        </div>
        <div class="mc-subcard mc-skel" style="height: 140px;"></div>
        <div class="mc-skel"
          style="height: 24px; width: 100%; border-radius: 4px; margin-bottom: 16px; margin-top: 8px;"></div>
        <div class="mc-month-layout">
          <div class="mc-subcard mc-skel" style="height: 160px;"></div>
          <div class="mc-subcard mc-skel" style="height: 160px;"></div>
        </div>
      </div>
      }
      }

      <!-- Real cards -->
      @if (!cardsLoading()) {
      @for (card of visibleMachineCards(); track card.machineId) {

      <div class="mc-card-wrapper">

        <!-- 1. HEADER (Card Level) -->
        <div class="mc-header" style="position: relative;">
          <div class="mc-machine-name">
            {{ card.machineName }}
          </div>

          <!-- Report buttons – top-right corner -->
          <div style="position: absolute; top: -6px; right: 0; display: flex; gap: 8px;">
            <button class="od-export-btn" title="Download Job Report"
              (click)="getJobReport(card.machineId, card.machineName)">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                <polyline points="7 10 12 15 17 10" />
                <line x1="12" y1="15" x2="12" y2="3" />
              </svg>
              Job Report
            </button>
            <button class="od-export-btn" title="Download Daily Report"
              (click)="getOperatorShiftReport(card.machineId, card.machineName)">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                <polyline points="7 10 12 15 17 10" />
                <line x1="12" y1="15" x2="12" y2="3" />
              </svg>
              Daily Report
            </button>
          </div>

          <div style="display:flex; align-items:center; gap:8px;">
            <div class="mc-status-pill" [ngClass]="{
          'status-green': card.machineStatus.toLowerCase().includes('operation') || card.machineStatus.toLowerCase().includes('make ready'),
          'status-red': card.machineStatus.toLowerCase().includes('hold'),
          'status-yellow': card.machineStatus.toLowerCase().includes('idle') || card.machineStatus.toLowerCase().includes('maintenance')
        }">
              <div class="mc-status-dot"></div>
              {{ card.machineStatus | uppercase }}
            </div>

          </div>
        </div>

        <!-- 2. CURRENT SHIFT ROW -->
        <div class="mc-section-header">
          <div class="mc-sh-title">
            <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
              <line x1="16" y1="2" x2="16" y2="6"></line>
              <line x1="8" y1="2" x2="8" y2="6"></line>
              <line x1="3" y1="10" x2="21" y2="10"></line>
            </svg>
            CURRENT SHIFT
          </div>
          <div class="mc-sh-pills">
            <div class="mc-pill">{{ card.currentShift }}</div>
            <div class="mc-pill">{{ card.currentRosterOperators.length > 0 ? card.currentRosterOperators.join(', ') :
              'Unassigned' }}</div>
            <div class="mc-pill">{{ card.shiftDate ? card.shiftDate : today }}</div>
          </div>
        </div>

        <div class="mc-row-2">
          <!-- Shift Output Box -->
          <div class="mc-subcard">
            @let shiftImp = getCurrentShiftImpression(card);
            <div class="mc-split-box">
              <div class="mc-split-col">
                <div class="mc-label">Shift Output</div>
                <div class="mc-val-large">{{ shiftImp.actualOutput | number }}</div>
              </div>
              <div class="mc-split-col">
                <div class="mc-label">Make Ready (MR)</div>
                <div class="mc-val-large">{{ shiftImp.makeReadyCount | number }}</div>
              </div>
            </div>
          </div>

          <!-- Vs Prev Shift Box -->
          <div class="mc-subcard bg-tint">
            <div class="mc-label">vs. prev. shift ({{ card.previousShiftOperators.length > 0 ?
              card.previousShiftOperators.join(', ') : 'Unassigned' }})</div>
            @if (getPreviousShiftDelta(card); as delta) {
            <div class="mc-val-medium" [class.text-red]="!delta.isAhead" [class.text-green]="delta.isAhead">
              {{ delta.isAhead ? '+' : '-' }}{{ delta.delta | number }} behind
            </div>
            }
            <div class="mc-sublabel">Prev. achieved: {{ card.previousShiftOutput !== null ? (card.previousShiftOutput |
              number) : 0 }}</div>
          </div>
        </div>

        <!-- 3. DAILY PROGRESS -->
        <div class="mc-subcard mc-progress-card">
          <div class="mc-progress-header">
            <div class="mc-ph-title">
              <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.5">
                <circle cx="12" cy="12" r="10" />
                <polyline points="12 6 12 12 16 14" />
              </svg>
              DAILY PROGRESS
            </div>
            @if (card.plannedImpression > 0) {
            @let diff = card.actualImpression - card.plannedImpression;
            <div class="mc-progress-pill" [class.bg-red]="diff < 0" [class.bg-green]="diff >= 0">
              {{ diff > 0 ? '' : '' }}{{ diff | number }} {{ diff > 0 ? 'AHEAD' : diff < 0 ? 'BEHIND' : 'ON TARGET' }}
                </div>
                }
                <div class="mc-ph-pct">
                  {{ card.plannedImpression > 0 ? ((card.actualImpression / card.plannedImpression) * 100 |
                  number:'1.0-0') : 0 }}%
                </div>
            </div>

            <div class="mc-progress-track">
              <div class="mc-progress-fill"
                [style.width.%]="card.plannedImpression > 0 ? ((card.actualImpression / card.plannedImpression) * 100) : 0">
              </div>
            </div>

            <div class="mc-progress-labels">
              <!-- <span>0</span>
            <span>{{ card.plannedImpression > 0 ? ((card.actualImpression / card.plannedImpression) * 100 | number:'1.0-0') : 0 }}% CURRENT</span>
            <span>100% TARGET</span> -->
            </div>

            <div class="mc-progress-stats">
              <div class="mc-pstat">
                <div class="mc-label-center">PLANNED</div>
                <div class="mc-val-center">{{ card.plannedImpression | number }}</div>
              </div>
              <div class="mc-pstat">
                <div class="mc-label-center">ACHIEVED</div>
                <div class="mc-val-center text-blue">{{ card.actualImpression | number }}</div>
              </div>
              <div class="mc-pstat">
                <div class="mc-label-center">TOTAL MR</div>
                <div class="mc-val-center">{{ card.makeReadyCount | number }}</div>
              </div>
            </div>
          </div>

          <!-- 4. JULY MONTH SECTION -->
          <div class="mc-section-header">
            <div class="mc-sh-title">
              <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.5">
                <rect x="4" y="4" width="16" height="16" rx="2" ry="2"></rect>
                <rect x="9" y="9" width="6" height="6"></rect>
                <line x1="9" y1="1" x2="9" y2="4"></line>
                <line x1="15" y1="1" x2="15" y2="4"></line>
                <line x1="9" y1="20" x2="9" y2="23"></line>
                <line x1="15" y1="20" x2="15" y2="23"></line>
                <line x1="20" y1="9" x2="23" y2="9"></line>
                <line x1="20" y1="14" x2="23" y2="14"></line>
                <line x1="1" y1="9" x2="4" y2="9"></line>
                <line x1="1" y1="14" x2="4" y2="14"></line>
              </svg>
              {{ selectedMonthName() | uppercase }} MONTH
            </div>
          </div>

          <div class="mc-month-layout">
            <!-- Left Column: Totals -->
            <div class="mc-subcard mc-totals-col">
              <div class="mc-totals-content">
                <div class="mc-mb-4">
                  <div class="mc-label">Monthly Total Output</div>
                  <div class="mc-val-xl">{{ (card.monthlyTotalOutput || 0) | number }}</div>
                </div>
                <div>
                  <div class="mc-label">Monthly Total MR</div>
                  <div class="mc-val-xl">{{ (card.monthlyTotalMakeReady || 0) | number }}</div>
                </div>
              </div>
              <!-- <button class="mc-btn-primary">VIEW FULL MONTHLY REPORT</button> -->
            </div>

            <!-- Right Column: Grid -->
            <div class="mc-month-grid">

              <!-- Top Operator (Full width of right col) -->
              @if (getTopOperatorsForMachine(card.machineId).length > 0) {
              <div class="mc-subcard">
                <div class="mc-topop-header">
                  <div class="mc-topop-title"><span class="mc-icon">🏆</span> TOP OPERATOR</div>
                  <div class="mc-topop-avatar">
                    <svg viewBox="0 0 24 24" width="32" height="32" fill="none" stroke="currentColor"
                      stroke-width="1.5">
                      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                      <circle cx="12" cy="7" r="4"></circle>
                    </svg>
                  </div>
                </div>
                <div class="mc-topop-name">{{ getTopOperatorsForMachine(card.machineId)[0].operatorName | uppercase }}
                </div>
                <div class="mc-topop-stats">
                  <div class="mc-ts">
                    <div class="mc-ts-lbl">TOTAL IMP</div>
                    <div class="mc-ts-val">{{ getTopOperatorsForMachine(card.machineId)[0].machineOutput | number }}
                    </div>
                  </div>
                  <div class="mc-ts">
                    <div class="mc-ts-lbl">AVG HOURLY</div>
                    <div class="mc-ts-val">{{ getTopOperatorsForMachine(card.machineId)[0].avgOutput | number }}/hr
                    </div>
                  </div>
                  <div class="mc-ts">
                    <div class="mc-ts-lbl">TOTAL MR</div>
                    <div class="mc-ts-val text-gold">{{ getTopOperatorsForMachine(card.machineId)[0].makeReadyCount |
                      number }} MR</div>
                  </div>
                </div>
              </div>
              }

            </div>
          </div>

          <div class="mc-grid-2">
            @for (shift of card.monthlyShiftOutputs; track shift.shiftId) {
            @let isNight = shift.shiftName.toLowerCase().includes('night');
            <div class="mc-subcard">
              <div class="mc-shift-header" [class.text-blue]="isNight">
                <span class="mc-icon">{{ isNight ? '☾' : '☼' }}</span> {{ isNight ? 'NIGHT SHIFT' : 'Day shift' }}
              </div>
              <div class="mc-val-xl text-center" [class.text-blue]="isNight">{{ shift.monthlyOutput | number }}</div>
              <div class="mc-shift-mr-pill">
                <span class="mc-icon">🔧</span> {{ shift.makeReadyCount || 0 }} Make Ready
              </div>
            </div>
            }
          </div>

          <div class="mc-grid-2">
            <!-- Operator Comparison -->
            <div class="mc-subcard">
              <div class="mc-sub-title">OPERATOR COMPARISON</div>
              <div class="mc-comp-list">
                @for (op of getComparisonOperators(card) | slice:0:2; track op.operatorName) {
                <div class="mc-comp-row">
                  <div class="mc-comp-name-row">
                    <span class="mc-comp-name">{{ op.operatorName }}</span>
                    <span class="mc-badge" [class.blue]="op.isTop" [class.green]="!op.isTop && op.isYou">{{ op.isTop ?
                      'Top' : op.isYou ? 'You' : '2nd' }}</span>
                  </div>
                  <div class="mc-comp-bar-track">
                    <div class="mc-comp-bar-fill" [class.blue]="op.isTop" [class.dark]="!op.isTop"
                      [style.width.%]="(op.machineOutput / getTopOperatorMonthlyOutput(card.machineId)) * 100"></div>
                  </div>
                  <div class="mc-comp-stats">
                    <span>{{ op.machineOutput | number }} imp</span>
                    <span>{{ op.makeReadyCount }} MR</span>
                  </div>
                </div>
                }
              </div>
            </div>

            <!-- Gap to Top -->
            <div class="mc-subcard mc-gap-card">
              <div class="mc-sub-title text-center">GAP TO TOP</div>
              @let gap = getOperatorGap(card);
              @if (gap) {
              @if (gap.isTop) {
              <div class="mc-val-huge text-blue text-center">0 <span class="mc-unit">imp</span></div>
              <div class="mc-gap-desc text-center text-bold">You are in the lead!</div>
              } @else {
              <div class="mc-val-huge text-red text-center">-{{ gap.behindCount | number }} <span
                  class="mc-unit">imp</span></div>
              <div class="mc-gap-desc text-center text-bold">Behind {{ gap.topOperatorName }}</div>
              <div class="mc-gap-sub text-center">{{ gap.behindPct }}% of top performance</div>
              }
              }
            </div>
          </div>

        </div><!-- end mc-card-wrapper -->
        }

        <!-- Empty state -->
        @if (machineCards().length === 0) {
        <div class="od-empty-cards">
          <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"
            opacity="0.4">
            <rect x="2" y="3" width="20" height="14" rx="2" />
            <line x1="8" y1="21" x2="16" y2="21" />
            <line x1="12" y1="17" x2="12" y2="21" />
          </svg>
          <p>No machines found for this section</p>
        </div>
        }
        }

      </div>

      @if (machineCards().length > 3) {
      <button class="od-scroll-btn right" (click)="nextCardPage()" title="Next Cards">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <polyline points="9 18 15 12 9 6"></polyline>
        </svg>
      </button>
      }
    </div>


    <!-- ═══ OPERATOR PERFORMANCE TABLE ════════════════════════════════ -->
    <!-- Operator Performance Metrics -->
    <div class="od-table-section">
      <div class="od-table-header">
        <div>
          <h3 class="od-table-title">Operator Performance Metrics</h3>
          <p class="od-table-sub">
            MONTHLY REPORT:
            {{ months[selectedMonth() - 1].label | uppercase }} {{ selectedYear() }}
          </p>
        </div>
        <button class="od-export-btn" title="Export Data" (click)="exportToExcel()">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
            <polyline points="7 10 12 15 17 10" />
            <line x1="12" y1="15" x2="12" y2="3" />
          </svg>
          Export Data
        </button>
      </div>

      <div class="od-table-wrap" #tableWrap>
        <table class="od-table">
          <thead>
            <tr>
              <th>OPERATOR NAME</th>
              <th>MONTHLY OUTPUT</th>
              <th>AVG OUTPUT</th>
              <th>PLANNED HOURS</th>
              <th>OPERATION HOURS</th>
              <th>HOLD HOURS</th>
              <th>MAKE READY</th>
              <th>IR</th>
              <th>CC</th>
              <th>NCR VALUE</th>
              <th>DAYS WORKED</th>
              <th>MACHINES</th>
            </tr>
          </thead>
          @if (isVisible()) {
          <tbody>
            @for (op of displayOperators(); track $index; let i = $index) {
            <tr [class.rank-one]="op.originalIndex === 0">
              <td class="od-td-operator">
                <span class="od-rank">{{ op.originalIndex + 1 }}</span>
                <span class="od-op-name">
                  {{ op.operatorName }}
                  @if (op.originalIndex === 0) {
                  <span class="od-best-badge">🏆 Best</span>
                  }
                </span>
              </td>
              <td class="od-td-bold">{{ op.totalOutput | number }}</td>
              <td class="od-td-bold">{{ op.avgHourlyOutput | number:'1.0-0' }}/hr</td>
              <td>{{ op.plannedHours }} h</td>
              <td>{{ op.totalHoursWorked }} h</td>
              <td>{{ op.totalHoursHold }} h</td>
              <td>{{ op.makeReadyCount }}</td>
              <td>{{ getOperatorIrCount(op.empNo) }}</td>
              <td>{{ getOperatorCcCount(op.empNo) }}</td>
              <td class="od-td-bold">LKR {{ getOperatorNcrTotalValue(op.empNo) | number:'1.2-2' }}</td>
              <td>{{ op.daysWorked }} Days</td>
              <td class="od-td-machines">
                @for (m of op.machines; track m.machineName; let last = $last) {
                <span class="od-machine-chip">{{ m.machineName }}</span>
                }
              </td>
            </tr>
            }
          </tbody>
          }
        </table>
      </div>
    </div>

  </div>